import * as VisuallyHidden from '@radix-ui/react-visually-hidden'
import { Dialog, DialogContent, DialogTitle } from '../ui/dialog'
import ApnSearchForm from './apn-search-form'

interface Props {
  isSearchOn: any
  onSearchSuccess: (county: string, apns: string[]) => void
  handleClose: () => void
}

export default function ApnSearchModal({
  isSearchOn,
  onSearchSuccess,
  handleClose,
}: Props) {
  return (
    <Dialog open={isSearchOn['apn']} onOpenChange={handleClose}>
      <DialogContent
        className="max-w-[350px]
        !overflow-visible !p-5 rounded-md !gap-2 w-full flex flex-col sm:rounded-md min-h-[306px]"
        onPointerDownOutside={(e) => e.preventDefault()}
      >
        <VisuallyHidden.Root>
          <DialogTitle />
        </VisuallyHidden.Root>
        <div className="flex justify-between items-center">
          <p className="text-xl font-medium">APN SEARCH</p>
          <button
            onClick={handleClose}
            className="handleClose-gray-500 hover:text-gray-700"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <ApnSearchForm
          onSubmit={(values) => {
            onSearchSuccess(values.county, values.apns)
          }}
        />
      </DialogContent>
    </Dialog>
  )
}
